import Swiper from "swiper";
import { A11y, Keyboard, Pagination } from "swiper/modules";

const MOBILE_QUERY = "(max-width: 767.98px)";

function setActiveMedia(root, index) {
  root.querySelectorAll("[data-media-accordion-media]").forEach((item) => {
    const isActive = item.dataset.mediaAccordionMedia === String(index);

    item.classList.toggle("is-active", isActive);

    if (isActive && item.querySelector("img")) {
      item.removeAttribute("aria-hidden");
    } else {
      item.setAttribute("aria-hidden", "true");
    }
  });
}

function setRowState(button, panel, isOpen) {
  button.classList.toggle("collapsed", !isOpen);
  button.setAttribute("aria-expanded", isOpen ? "true" : "false");
  panel.classList.toggle("show", isOpen);
}

function initAccordion(root) {
  const accordion = root.querySelector(".media-accordion__accordion");

  if (!accordion) {
    return;
  }

  const buttons = [...accordion.querySelectorAll(".media-accordion__button")];

  const panelFor = (button) =>
    accordion.querySelector(`#${CSS.escape(button.getAttribute("aria-controls"))}`);

  buttons.forEach((button) => {
    const panel = panelFor(button);

    if (!panel) {
      return;
    }

    button.addEventListener("click", () => {
      const isOpen = panel.classList.contains("show");

      buttons.forEach((sibling) => {
        const siblingPanel = panelFor(sibling);

        if (siblingPanel && siblingPanel !== panel) {
          setRowState(sibling, siblingPanel, false);
        }
      });

      setRowState(button, panel, !isOpen);

      if (!isOpen) {
        setActiveMedia(root, button.dataset.mediaAccordionIndex);
      }
    });
  });
}

function initCarousel(root) {
  const el = root.querySelector("[data-media-accordion-carousel]");

  if (!el) {
    return null;
  }

  const mq = window.matchMedia(MOBILE_QUERY);
  let swiper = null;

  const teardown = () => {
    mq.removeEventListener("change", sync);

    if (swiper) {
      swiper.destroy(true, false);
      swiper = null;
    }
  };

  const sync = () => {
    if (mq.matches && !swiper) {
      swiper = new Swiper(el, {
        modules: [A11y, Keyboard, Pagination],
        slidesPerView: "auto",
        spaceBetween: 16,
        keyboard: { enabled: true, onlyInViewport: true },
        pagination: {
          el: el.querySelector(".media-accordion__pagination"),
          clickable: true,
        },
      });
    } else if (!mq.matches && swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
  };

  sync();
  mq.addEventListener("change", sync);

  return teardown;
}

const teardowns = new Set();

function init() {
  teardowns.forEach((teardown) => {
    if (teardown.isDead()) {
      teardown.run();
      teardowns.delete(teardown);
    }
  });

  document.querySelectorAll(".media-accordion").forEach((root) => {
    if (root.dataset.mediaAccordionReady) {
      return;
    }

    root.dataset.mediaAccordionReady = "true";

    initAccordion(root);

    const teardownCarousel = initCarousel(root);

    if (teardownCarousel) {
      teardowns.add({
        isDead: () => !root.isConnected,
        run: teardownCarousel,
      });
    }
  });
}

const BOOTED_FLAG = "__eaplusMediaAccordionBooted";

// main.js and block-editor.js each bundle their own copy of this module, and the
// editor loads both, so the guard has to live on window rather than in module scope.
export function bootstrap() {
  init();

  if (
    window[BOOTED_FLAG] ||
    typeof window.acf === "undefined" ||
    !window.acf.addAction
  ) {
    return;
  }

  window[BOOTED_FLAG] = true;

  window.acf.addAction("render_block_preview/type=media-accordion", init);
  window.acf.addAction("append", init);
}
